import React, { useEffect, useState, useMemo } from "react";
import { listApi } from "../../../../services/Admin/request";
import useAuth from "../../../../hooks/useAuth";
import TableC from "../../../../components/Admin/TableC";
import timestampToDate from "../../../../components/timestampToDate";
import { Grid, Button } from "@mui/material";
import { RouteAdmin } from "../../../../routes/RouteAdmin";
import LoadingProgress from "../../../../components/LoadingProgress";
import ManageWorkersModal from "../../../../components/Admin/ManageWorkersModal";
import Card from "../../../../components/Admin/Card";

export default function Management() {
    const [productos, setProductos] = useState([])
    const [loading, setLoading] = useState(true)
    const { auth, login } = useAuth()
    const isSuperAdmin = auth ? auth?.primaryUser?.isSuperAdmin : 0
    const [openModal, setOpenModal] = useState(false);
    const [selectedManager, setSelectedManager] = useState(null);
    const [globalFilter, setGlobalFilter] = useState("")

    const columns = useMemo(() => {
        const cols = [
            {
                Header: "ACTIVO",
                accessor: "active",
            },
            {
                Header: "TIPO DE USUARIO (ROLE)",
                accessor: "role",
            },
            {
                Header: "NOMBRE",
                accessor: "name",
            },
            {
                Header: "EMAIL",
                accessor: "email",
            },
        ];
        if (isSuperAdmin) {
            cols.push({
                Header: "ORGANIZACIONES",
                accessor: "organizations",
            });
        }
        cols.push(
            {
                Header: "ACCESO A LA PLATAFORMA",
                accessor: "access",
            },
            {
                Header: "EMAIL FACTURACIÓN",
                accessor: "emailFacturacion",
            },
            {
                Header: "FACTURACIÓN AUTOMATICA",
                accessor: "fAuto",
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }
        );
        return cols;
    }, [isSuperAdmin]);

    useEffect(() => {
        getList()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getList = async () => {
        setLoading(true)
        listApi("user").then(resp => {
            manejarSnapshot(resp.data.data)
            setLoading(false)
        }).catch(error => {
            console.error(error)
            setLoading(false)
        })
    }

    const manejarSnapshot = (snapshot) => {
        const productos = snapshot.map((doc) => {
            let href = `${RouteAdmin.USER_EDIT.path}/${doc.id}`;

            const roleCode = doc.role
            let role = "";
            switch (doc.role) {
                case "ROLE_ADMIN":
                    role = "Administrador"
                    break;
                case "ROLE_WORKER":
                    role = "Trabajador"
                    break;
                case "ROLE_CLIENT":
                    role = "Cliente"
                    break;
                case "ROLE_MANAGER":
                    role = "Gestor"
                    break;
                case "ROLE_IA_CONNECTOR":
                    role = "Conector IA"
                    break;
                default:
                    role = ""
                    break;
            }
            let access = "No";
            if (doc.isActive) {
                access = "Sí";
            }

            let fAuto = "No";
            if (doc.fAuto) {
                fAuto = "Sí";
            }


            return {
                ...doc,
                id: doc.id,
                role: role,
                access: access,
                fAuto: fAuto,
                organizations: doc.organizations,
                active: timestampToDate(doc.lastActivity, false),
                actions: (
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            href={href}
                            sx={{
                                borderRadius: 2,
                                paddingLeft: 2,
                                paddingRight: 2,
                                textTransform: 'none',
                                fontWeight: 500,
                                boxShadow: 'none'
                            }}
                        >
                            Editar
                        </Button>
                        {roleCode === "ROLE_MANAGER" && (
                            <Button
                                variant="outlined"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                    setSelectedManager(doc);
                                    setOpenModal(true);
                                }}
                                sx={{
                                    borderRadius: 2,
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    boxShadow: 'none'
                                }}
                            >
                                Gestionar
                            </Button>
                        )}
                    </div>
                ),
            };
        });
        setProductos(productos);
    }

    // --- Filtro global aplicado a productos ---
    const filteredProductos = useMemo(() => {
        if (!globalFilter) return productos;
        const search = globalFilter.toLowerCase();
        return productos.filter(row =>
            Object.values(row).some(
                val =>
                    typeof val === 'string' && val.toLowerCase().includes(search)
            )
        );
    }, [productos, globalFilter]);

    return (
        <Card>
            <div className="cointainer">
                <h1>Usuarios</h1>
                {!loading && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%' }}>
                        <Button
                            variant="outlined"
                            color="primary"
                            style={{ width: 200 }}
                            href={RouteAdmin.USER_CREATE.path}
                        >
                            Añadir
                        </Button>
                    </div>
                )}
            </div>

            <LoadingProgress loading={loading} />
            {!loading && (
                <>
                    <TableC
                        columns={columns}
                        data={filteredProductos}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                    />
                </>
            )}

            <ManageWorkersModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                manager={selectedManager}
            />
        </Card>
    );
}
